// extracted by mini-css-extract-plugin
export default {"files":"Files_files__k+8EU","file__item":"Files_file__item__i2Rmq"};